import React, { useState, useRef, useLayoutEffect, forwardRef } from 'react';
import { Wrapper, Icon } from '@/components';
import { Shop } from '@/sunzi';
import { i18n, thumbnail7n } from '@/utils';
import { SockData, SockBottomImage, ProductType } from './new-sock';
import ChooseColor from './choose-color';
import styles from './style.less';

interface ApendProps {
  /** 店铺信息 */
  shop: Shop;
  /** apend 函数 */
  apendRefFunction: any;
  /** 追加定制数据 */
  apendSockData: SockData[];
  /** 变体切换 */
  onVariantChange: (data: ProductType) => void;
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: (apendData?: { sizeId: string, colorId: string }) => void;
}

const Apend: React.FC<ApendProps> = ({ shop, apendRefFunction, apendSockData, onVariantChange, onClose, onConfirm }) => {

  /** 底图已选择名字 */
  const colorNameSelected = useRef<string>(apendSockData[0].bottomImages[0].name);
  /** 选择的尺寸 */
  const [ sizeSelected, setSizeSelected ] = useState<SockData>(apendSockData[0]);
  /** 选择的颜色 */
  const [ colorSelected, setColorSelected ] = useState<SockBottomImage>(apendSockData[0].bottomImages[0]);
  /** 选择颜色显影 */
  const [colorDrawerVisible, setColorDrawerVisible] = useState<boolean>(false);
  /** 追加产品价格 */
  const [allPrice, setAllPrice] = useState<{price: number; originPrice: number;}>({
    price: 0,
    originPrice: 0,
  });
  /** 产品主图 */
  const [album, setAlbum] = useState<string>('');
  /** 底色数组 */
  let colors: SockBottomImage[] = [];
  apendSockData.forEach(item => {
    if (item.id == sizeSelected.id) {
      colors = item.bottomImages;
    }
  });

  useLayoutEffect(() => {
    apendRefFunction(() => {
      return {
        setPrice: (price: number, originPrice: number) => {
          setAllPrice({
            price,
            originPrice,
          });
        },
        setAlbum: (album: string) => setAlbum(album),
      }
    })
    return () => apendRefFunction(undefined)
  }, [apendRefFunction]);

  useLayoutEffect(() => {
    onVariantChange({
      size: sizeSelected.id,
      color: colorSelected.id,
    });
  }, [sizeSelected, colorSelected]);

  /** 选择尺寸 */
  const handleSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const id = event.target.value;
    const size = apendSockData.find((item) => item.id == id)!;
    const color = size.bottomImages.find(item => item.name === colorNameSelected.current) ?? size.bottomImages[0];
    setSizeSelected(size);
    setColorSelected(color);
  }

  /** 选择颜色确认 */
  const handleChooseColorConfirm = (color: SockBottomImage) => {
    colorNameSelected.current = color.name;
    setColorSelected(color);
    setColorDrawerVisible(false);
  }

  return (
    <Wrapper className={styles.apendWrapper}>
      <div className={styles.apend}>
        <div className={styles.previous} onClick={onClose}>
          <Icon type='arrow-left' size={30} color='#333' />
        </div>
        <div className={styles.header}>
          <div className={styles.title}>
            {i18n.format('modules.new.sock.limited.offer')}
          </div>
          <div className={styles.detail}>
            {i18n.format('modules.new.sock.only')} <span className={styles.originPrice}>{`${shop.currencySymbol}${allPrice.originPrice}`}</span> <span className={styles.price}>{`${shop.currencySymbol}${allPrice.price}`}</span> {i18n.format('modules.new.sock.get.sock')}
          </div>
        </div>
        <div className={styles.content}>
          <div style={{ backgroundImage: album && `url(${thumbnail7n(album, 300)})` }} className={styles.album}>
            <div className={styles.discount}>
              50%OFF
            </div>
          </div>
          <div className={styles.options}>
            <div className={styles.optionSize}>
              <div className={styles.label}>{`${i18n.format('modules.new.sock.size')}:`}</div>
              <div className={styles.sizeValue}>{sizeSelected.size}</div>
              <div className={styles.icon}>
                <Icon type='down' size={20} color='#333' />
              </div>
              <select value={sizeSelected.id} onChange={handleSizeChange}>
                {apendSockData.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.size}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.optionColor} onClick={() => setColorDrawerVisible(true)}>
              <div className={styles.label}>{`${i18n.format('modules.new.sock.color')}:`}</div>
              <div className={styles.valueWrapper}>
                {(() => {
                  const backgroundImage = colorSelected.variantImage || colorSelected.image;
                  const isImage = backgroundImage.includes('http');
                  return <div
                    style={{
                      backgroundImage: isImage ? `url(${backgroundImage})` : undefined,
                      backgroundColor: !isImage ? backgroundImage : undefined,
                    }}
                    className={styles.colorValue}
                  />
                })()}
              </div>
              <div className={styles.icon}>
                <Icon type='down' size={20} color='#333' />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.confirm} onClick={() => onConfirm({ sizeId: sizeSelected.id, colorId: colorSelected.id })}>
            <div className={styles.icon}>
              <Icon type='cart' size={30} color='#fff' />
            </div>
            {i18n.format('modules.new.sock.buy.now')}
          </div>
          <div className={styles.cancel} onClick={() => onConfirm()}>
            {i18n.format('modules.new.sock.no.thanks.add.cart')}
          </div>
        </div>
      </div>
      {colorDrawerVisible &&
        <ChooseColor
          colors={colors}
          selectedColor={colorSelected}
          onClose={() => setColorDrawerVisible(false)}
          onConfirm={handleChooseColorConfirm}
        />
      }
    </Wrapper>
  );
}

export default Apend;
